import { render, staticRenderFns } from "./ExtraForm.vue?vue&type=template&id=1415c024&scoped=true"
import script from "./ExtraForm.vue?vue&type=script&lang=js"
export * from "./ExtraForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415c024",
  null
  
)

export default component.exports